import { useMutation, useQuery, useQueryClient } from 'react-query';

import api from '../utils/api';

/**
 * POST /v1/subscriptions/card
 *
 * Creates new subscription card
 * @param {{ token: string, last4: string, country: string, brand: string }} {data}
 * @returns {Promise}
 */
const createCard = ({ data }) => api.post('/v1/subscriptions/card', data);

/**
 * GET /v1/subscriptions
 * @returns {Promise} Promise containing subscription info
 */
const fetchSubscription = () => api.get('/v1/subscriptions');

/**
 * POST /v1/subscriptions
 *
 * Creates a new subscription
 * @param {{ planId: string coupon: string }} {data}
 * @returns {Promise}
 */
const createSubscription = ({ data }) => api.post('/v1/subscriptions', data);

/**
 * PUT /v1/subscriptions/{subscriptionId}
 *
 * Updates and existing subscription by subscriptionId
 * @param {Object} params
 * @param {Object} params.data - data to be submitted
 * @param {string} params.data.planId - planId
 * @param {string} params.data.coupon - coupon code
 * @param {string} params.subscriptionId - subscriptionId
 * @returns {Promise}
 */
const updateSubscription = ({ data, subscriptionId }) =>
  api.put(`/v1/subscriptions/${subscriptionId}`, data);

// queries
export const useFetchSubscription = () => useQuery(['subscription'], fetchSubscription);
// mutations
export const useCreateCard = () => {
  const queryClient = useQueryClient();

  return useMutation(createCard, {
    onSuccess: () => {
      queryClient.invalidateQueries(['billingData']);
      queryClient.invalidateQueries(['subscription']);
    }
  });
};

export const useCreateSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation(createSubscription, {
    onSuccess: () => {
      queryClient.invalidateQueries(['eligiblePlans']);
      queryClient.invalidateQueries(['billingData']);
    }
  });
};
export const useUpdateSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation(updateSubscription, {
    onSuccess: () => {
      queryClient.invalidateQueries(['eligiblePlans']);
      queryClient.invalidateQueries(['billingData']);
    }
  });
};



// WEBPACK FOOTER //
// ./src/hooks/useSubscriptionData.js